import { useMutation, useQueryClient } from '@tanstack/react-query';

import { commentsApi } from '@/lib/api/comments.api';

export function useAddComment(callId: string) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (content: string) => commentsApi.addComment(callId, content),
    onSuccess: () => {
      // Invalidate the call query to refetch with new comments
      queryClient.invalidateQueries({ queryKey: ['calls', callId] });
    },
  });
}

export function useDeleteComment(callId: string) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (commentId: string) => commentsApi.deleteComment(commentId),
    onSuccess: () => {
      // Invalidate the call query to refetch with updated comments
      queryClient.invalidateQueries({ queryKey: ['calls', callId] });
    },
  });
}
